import React from 'react';
export function PainSection() {
  return <section className="bg-gray-50 py-6 md:py-8 px-4" data-id="element-127">
      <div className="max-w-3xl mx-auto" data-id="element-128">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 text-center" data-id="element-129">
          Si sos docente de Psicología, esto te va a sonar familiar…
        </h2>

        <div className="space-y-3 text-lg text-gray-700" data-id="element-130">
          <div className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-131">
            <p className="font-medium" data-id="element-132">
              Llegás del colegio agotado/a y todavía tenés que planificar.
            </p>
          </div>

          <div className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-133">
            <p className="font-medium" data-id="element-134">
              Horas armando clases sobre corrientes psicológicas, procesos
              mentales, adolescencia, identidad, emociones…
            </p>
          </div>

          <div className="bg-white p-4 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-135">
            <p className="font-medium" data-id="element-136">
              Preparando evaluaciones claras, buscando actividades que realmente
              enganchen, tratando de que los contenidos no queden solo en
              teoría.
            </p>
          </div>
        </div>

        <div className="mt-5 text-center" data-id="element-137">
          <p className="text-xl md:text-2xl font-bold text-gray-800" data-id="element-138">
            No es falta de capacidad. <br className="md:hidden" data-id="element-139" />
            <span className="bg-yellow-200 px-1" data-id="element-140">
              Es que te falta un sistema completo que te sostenga todo el año.
            </span>
          </p>
        </div>
      </div>
    </section>;
}